import { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';

import { Box } from '@mui/material';
import { baseLayoutBoxSx } from 'src/common/CommomSxs';

/**
 * The properties for the BaseLayout component.
 *
 * @interface
 */
interface BaseLayoutProps {
  children?: ReactNode;
}

/**
 * A base layout component that provides the basic structure for pages.
 *
 * @param {BaseLayoutProps} props - The properties of the component.
 * @param {ReactNode} [props.children] - The child components to render within the layout.
 *
 * @returns {JSX.Element} The JSX element representing the BaseLayout.
 */
const BaseLayout: FC<BaseLayoutProps> = ({ children }) => {
  return <Box sx={baseLayoutBoxSx}>{children || <Outlet />}</Box>;
};

(BaseLayout as any).propTypes = {
  children: PropTypes.node
};

export default BaseLayout;
